import { AdvertisementsData, AdvertisementsSponsorItem } from "@/types/ads";
import { api } from "@/utils/util";
import { useQuery } from "react-query";

export const useAdvertisementsSponsor = (advertisement: string) => {
  return useQuery<AdvertisementsSponsorItem[]>({
    queryKey: ["advertisementsSponsor", advertisement],
    queryFn: () =>
      api.get(`/advertisements/sponsor?advertisementType=${advertisement}`).then((res) => res.data),
    enabled: !!advertisement,
  });
};

export const useAdvertisementsOpeningHomeOnlySponsor = () => {
  return useQuery<AdvertisementsSponsorItem[]>({
    queryKey: ["advertisementsOpeningHomeOnlySponsor"],
    queryFn: () => api.get(`/advertisements/sponsor?openingHomeOnly=true`).then((res) => res.data),
  });
};

// /advertisements/:adsid
export const useSdvertisements = (adsid: string) => {
  return useQuery<AdvertisementsData>({
    queryKey: ["advertisements", adsid],
    queryFn: () => api.get(`/advertisements/${adsid}`).then((res) => res.data[0]),
    enabled: !!adsid,
  });
};
